import {GenericService} from '@/shared/xhttp';
import {Upload} from '@/models';

export class UploadService extends GenericService<Upload> {
	public postLogo(upload: Upload): Promise<Upload> {
		return this.post(`/organisation/logo`, upload);
	}
}
